<template>
  <div class="collectOperas">
    <el-form ref="costForm" :model="costForm" :rules="rules" label-width="120px">
      <!-- 支付方式 -->
      <template v-if="dialogType === 1">
        <div class="payChoose">
          <el-row>
            <el-col>
              <el-form-item label="支付选择" class="fontWeight">
                <el-col :span='6' v-for="(i,index) in 4" :key="'pay-'+index">
                  <div :class="['paystyle','paystyle'+index,{'active':index == activeName}]" @click="choosePayamount(index)">
                    <span>{{index == 0 ? '现金':(index == 1 ? '支付宝':(index == 2?'微信':'银行卡'))}}</span>
                  </div>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="17">
              <el-form-item label="支付金额" :prop="activeName == 0? 'cash':(activeName == 1?'alipayMoney':(activeName == 2?'wechatpayMoney':'bankMoney'))">
                  <el-input v-model="payAmount" placeholder="¥ 0.00" autocomplete="off" style="width:260px" @keyup.enter.native="confirmPay" class="memMoney choosepayMoney redFont"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="accountMoney">
            <div class="putUp" v-if="putUpFlag" @click="putUpItem">收起</div>
            <div class="putUp putDown" v-else @click="putUpItem">展开</div>
            <template v-if="putUpFlag">
              <el-row>
                <el-col>
                  <el-form-item label-width="100px" label="充值账户" class="fontWeight">
                    <el-form-item label-width="110px" label="充值账户" prop="rechargeAccountMoney">
                      <el-input v-model="costForm.rechargeAccountMoney" autocomplete="off" placeholder="请输入金额" style="width:130px"></el-input>
                      <span class="account">余额&nbsp;&nbsp;¥ {{memInfo.accountOffList&&memInfo.accountOffList[0] ? memInfo.accountOffList[0].rechargeOff.toFixed(2) : '0.00'}}</span>
                    </el-form-item>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">
                  <div class="seize"></div>
                </el-col>
                <el-col :span="17">
                  <el-form-item label="赠送账户" prop="giftAccountMoney">
                    <el-input v-model="costForm.giftAccountMoney" autocomplete="off" placeholder="请输入金额" style="width:130px"></el-input>
                    <span class="account">余额&nbsp;&nbsp;¥ {{memInfo.accountOffList&&memInfo.accountOffList[0] ? memInfo.accountOffList[0].giftOff.toFixed(2) : '0.00'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">
                  <div class="seize"></div>
                </el-col>
                <el-col :span="17">
                  <el-form-item label="返现账户" prop="returnMoney">
                    <el-input v-model="costForm.returnMoney" autocomplete="off" placeholder="请输入金额" style="width:130px"></el-input>
                    <span class="account">余额&nbsp;&nbsp;¥ {{memInfo.accountOffList&&memInfo.accountOffList[0] ?　memInfo.accountOffList[0].backOff.toFixed(2): '0.00'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              </template>
              <template v-else>
                <el-row>
                  <el-col>
                    <el-form-item label-width="100px" label="充值账户" class="fontWeight">
                      <div class="centerFont">余额  ¥ {{memInfo.accountOffList&&memInfo.accountOffList[0] ? memInfo.accountOffList[0].rechargeOff.toFixed(2) : '0.00'}}</div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
            </div>
          <el-row class="totalAmount">
              <el-col :span="12">
                  <p>应收<span>¥ {{total}}</span></p>
              </el-col>
              <el-col :span="12">
                  <p class="netreceipts">实收<span>¥ {{paidInAmount}}</span></p>
              </el-col>
              <el-col :span="12">
                  <p>找零<span>¥ {{giveChange}}</span></p>
              </el-col>
          </el-row>
          <el-row class="dialogbtnOptions">
            <el-button class="darkBtn" @click="close">取消</el-button>
            <el-button class="redBtn" @click="confirmPay" :disabled="clickFalg">确定</el-button>
          </el-row>
        </div>
      </template>
      <template v-else-if="dialogType === 2">
        <el-row class="maxInfo" v-if="!$store.state.userInfo.storeList && Number($store.state.userInfo.maxDiscount) > 0">
          <p>订单合计价格：{{total}}元</p>
          <p class="red">您的最大折扣权限：<span class="discount">{{$store.state.userInfo.maxDiscount}}折</span>，请谨慎使用！</p>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="折扣" prop="moneyDiscount">
                <el-input v-model="costForm.moneyDiscount" autocomplete="off" placeholder="支持 0.1-9.9 折" style="width:166px"></el-input>&nbsp;&nbsp;折
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="maxInfo" v-if="!$store.state.userInfo.storeList && Number($store.state.userInfo.maxDiscount) > 0">
          <p>折扣后合计价格：{{MaxDiscountMoney}}元</p>
        </el-row>
        <!-- <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="折扣密码" prop="discountPwd">
              <el-input v-model="costForm.discountPwd" autocomplete="off" type="passWord" placeholder="请输入6位数密码" style="width:220px"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row class="dialogbtnOptions">
          <el-button class="redBtn" @click="submit(costForm.moneyDiscount)">确定</el-button>
        </el-row>
      </template>
      <template v-else-if="dialogType === 3">
        <el-row class="maxInfo" v-if="!$store.state.userInfo.storeList && Number($store.state.userInfo.maxMaling) > 0">
          <p>订单合计价格：{{molingTotal}}元</p>
          <p class="red">您的最大可抹零额度：<span class="discount">{{$store.state.userInfo.maxMaling}}元</span>，请谨慎使用！</p>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="抹零金额" prop="oddNumber">
                <el-input v-model="costForm.oddNumber" autocomplete="off" placeholder="100以内数值" style="width:166px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="maxInfo" v-if="!$store.state.userInfo.storeList && Number($store.state.userInfo.maxMaling) > 0">
          <p>抹零后合计价格：{{MaxMolingMoney}}元</p>
        </el-row>
        <el-row class="dialogbtnOptions">
          <el-button class="redBtn" @click="submit(Number(costForm.oddNumber))">确定</el-button>
        </el-row>
      </template>
      <template v-else-if="dialogType === 5">
        <el-row class="maxInfo" v-if="!$store.state.userInfo.storeList && Number($store.state.userInfo.maxPreferential) > 0">
          <p>订单合计价格：{{huiTotal}}元</p>
          <p class="red">您的最大可优惠额度：<span class="discount">{{$store.state.userInfo.maxPreferential}}元</span>，请谨慎使用！</p>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="优惠后合计" prop="feepick">
                <el-input v-model="costForm.feepick" autocomplete="off" placeholder="" style="width:166px"></el-input>&nbsp;&nbsp;元
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialogbtnOptions">
          <el-button class="redBtn" @click="submit(costForm.feepick == '' ? 0 : (Number(huiTotal) - Number(costForm.feepick)) )">确定</el-button>
        </el-row>
      </template>
      <template v-else-if="dialogType === 4">
        <div style="padding:0 25px">
            <el-row>
                <div class="red">注：选中后双击即可回到结算页</div>
            </el-row>
            <el-table
                :data="tableData"
                border
                height="500"
                ref="multipleTable"
                :cell-style="{height:'42px'}"
                @cell-dblclick="changeCheck"
                style="width: 100%" :header-cell-style="{background:'#EFF1F5',height:'47px'}">
                <el-table-column align="center" prop="id" label="选择" width="60">
                    <template slot-scope="scope">
                        <el-checkbox-group class="checkBoxcom noLabel" v-model="choosecurRow" @change="changeCheck">
                            <el-checkbox :label="scope.row"><span></span></el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createTime" label="挂单时间" width='160'>
                  <template slot-scope="scope">
                    {{scope.row.createTime | filterRow}}
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="memberName" label="会员"></el-table-column>
                <el-table-column align="center" prop="memberTelephone" label="手机号"></el-table-column>
                <el-table-column align="center" prop="orderGoodsList" label="项目">
                    <template slot-scope="scope">
                      <el-row class="tableGoods">
                        <el-popover trigger="hover" placement="top">
                          <span v-for="(i,index) in scope.row.orderGoodsList" :key="index">{{i.totalName}}{{scope.row.orderGoodsList.length-1 == index ? '' : '，'}}</span>
                          <el-col slot="reference" class="myTitle">
                              <span v-for="(i,index) in scope.row.orderGoodsList" :key="index">{{i.totalName}}{{scope.row.orderGoodsList.length-1 == index ? '' : '，'}}</span>
                          </el-col>
                        </el-popover>
                      </el-row>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="salesmanName" label="销售员"></el-table-column>
                <el-table-column align="center" prop="amountReceivable" label="应付金额">
                    <template slot-scope="scope">
                        {{'￥'+Number(scope.row.amountReceivable).toFixed(2)}}
                    </template>
                </el-table-column>
            </el-table>
            <el-row class="dialogbtnOptions">
                <el-button class="darkBtn" @click="reset">清除</el-button>
                <el-button class="redBtn" @click="payTotal">结算</el-button>
            </el-row>
        </div>
      </template>
    </el-form>
    <!-- 结算 -->
    <div id="printCont" style="display:none">
      <div class="contBox">
        <div class="cont">
        <div>单号：{{printDataPost.orderId}}</div>
        <div>收银员：{{printDataPost.cashierName}}</div>
        <div>营业员：{{printDataPost.salesmanName}}</div>
        <div>购买时间：{{printDataPost.createTime}}</div>
        </div>
        <div class="table">
        <div>
          <div class='span8'>服务名称</div>
          <div class='span4'>数量</div>
          <div class='span6'>单价</div>
          <div class='span6'>金额</div>
        </div>
        <div v-for="(i,index) in transmitPost.orderGoodsList" :key="index">
          <div class='span8'>{{i.totalName}}</div>
          <div class='span4' style="vertical-align:top">{{i.saleNumber}}</div>
          <div class='span6' style="vertical-align:top">{{i.originalPrice?Number(i.originalPrice).toFixed(2):'0.00'}}</div>
          <div class='span6' style="vertical-align:top">{{i.originalPrice?(i.originalPrice*i.saleNumber).toFixed(2):'0.00'}}</div>
        </div>
        </div>
        <div class="cont">
        <div>会员姓名：{{printDataPost.memberName}}</div>
        <div>会员联系方式：{{printDataPost.memberTelephone?(printDataPost.memberTelephone.substr(0,3)+'****'+printDataPost.memberTelephone.substr(7)):''}}</div>
        <div>服务项目数量：{{transmitPost.orderGoodsList.length}}</div>
        <div>应收金额：¥{{printDataPost.amountReceivable?printDataPost.amountReceivable.toFixed(2):'0.00'}}</div>
        <div>支付方式：
          <template v-if="printDataPost.orderType == 2">
          <div style="margin-top:-1.3em">
            <div style="margin:0 0 0 4.5em" v-for="(i,index) in printDataPost.payfeeType" :key="index">{{i}}</div>
          </div>
          </template>
          <span v-else>--</span></div>
        <div>优惠金额：¥{{printDataPost.amountSale}}</div>
        <div>找零金额：¥{{printDataPost.giveChange}}</div>
        </div>
        <div class="printbottomset">
        <div>{{printBottomContent}} <span style="margin-left: 5%;">{{LodoDate}}</span></div>
        <div>{{$store.state.userInfo.brandId == 1?"产后恢复，当然婷美！":'孩子少生病，全家都省心！'}}</div>
        <div>凭电话号码和姓名消费，注意保密！</div>
        </div>
	   </div>
	  </div>
  </div>
</template>
<script>
import {storeInfo, addSaleOrder, queryRestOrder, checkDiscountKey, deleteRestOrder} from '@/api'
import {formatDate} from '@/components/common/js/date.js';
import CryptoJS from 'crypto-js'
let LODOP//声明为全局变量

export default {
  props: ['dialogType','memInfo','maxPayInfo','transmitPost','feepickNum','total','listGoodsId','dialogTableVisible','onpostFlag'],
  data() {
    // 价格
    const isvalidateMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > 99999.99) {
			// this.$store.state.userInfo.brandId == 1 ? 99999.99:99999.99
          callback(new Error("金额最大"+99999.99));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 价格小于余额
    const isvalidateRechargeMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > this.NumbertoFix(this.memInfo.accountOffList[0].rechargeOff)) {
          callback(new Error("账户余额最大"+this.memInfo.accountOffList[0].rechargeOff));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const isvalidateGiftMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > this.NumbertoFix(this.memInfo.accountOffList[0].giftOff)) {
          callback(new Error("账户余额最大"+this.memInfo.accountOffList[0].giftOff));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const isvalidateReturnMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > this.NumbertoFix(this.memInfo.accountOffList[0].backOff)) {
          callback(new Error("账户余额最大"+this.memInfo.accountOffList[0].backOff));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 数字(一位小数)打折
    const isvalidateNumberPoint = (rule, value, callback) => {
      if(value > 0){
        let curDiscount = this.maxPayInfo.discountNum ? (this.maxPayInfo.discountNum*value)/10 : value
        if (Number(this.total) <= 0) {
          callback(new Error("应收金额需大于0"));
        }else if (value != null && value != "") {
          if (/^\d*\.{0,1}\d{0,1}$/.test(value) == false) {
            callback(new Error("请输入数字，最多一位小数"));
          } else if(Number(this.$store.state.userInfo.maxDiscount) > 0 && curDiscount < this.$store.state.userInfo.maxDiscount){
            callback(new Error("您已超出您的最大折扣权限"));
          }else if (value > 9.9) {
            callback(new Error("只能输入0.1-9.9的数值"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }else{
        callback(new Error("只能输入0.1-9.9的数值"));
      }
    };
    // 密码
    var validatePass = (rule, value, callback) => {
      var reg = /^\+?[0-9][0-9]*$/;
      if (value != null && value != "") {
        if (!reg.test(value)) {
            callback(new Error("密码输入有误"));
        } else if (value.length < 6) {
            callback(new Error("密码太短"));
        } else if (value.length > 6) {
            callback(new Error("密码长度只可以是6位"));
        } else {
            callback();
        }
      } else {
        callback();
      }
    };
    // 抹零
    const isvalidateoddMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (Number(value) > Number(this.total)) {
          callback(new Error("不能大于应收金额"));
        } else if (value > 100) {
          callback(new Error("只能输入100以内数值"));
        } else if (Number(this.$store.state.userInfo.maxMaling) > 0 && value > this.$store.state.userInfo.maxMaling) {
          callback(new Error("您已超出您的最大可抹零额度"));
        } else {
          callback();
        }
      }else if(value <= 0){
        callback(new Error("金额只能为正数或者两位小数"));
      } else {
        callback();
      }
    };
    // 优惠
    const isvalidatefeeMoney = (rule, value, callback) => {
      if(value == null || value == ""){
        callback(new Error("请输入优惠金额"));
      }else if (value != null && value != "") {
        if (/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (Number(this.$store.state.userInfo.maxPreferential) > 0 && (Number(this.huiTotal) - Number(value)) > this.$store.state.userInfo.maxPreferential) {
          callback(new Error("您已超出您的最大可优惠额度"));
        } else if (Number(value) > Number(this.huiTotal)) {
          callback(new Error("不能大于应收金额"));
        } else if (Number(value) > 999999.99) {
          callback(new Error("金额最大999999.99"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      payAmount:'',
      costForm: {
        cash:'',
        wechatpayMoney: '',
        alipayMoney:'',
        bankMoney:'',
        rechargeAccountMoney:'',
        giftAccountMoney:'',
        returnMoney:'',
        moneyDiscount:0,
        // discountPwd:'',
        oddNumber:0,
        feepick:'',//优惠
      },
      activeName:0,
      tableData:[],
      choosecurRow:[],
      rules: {
          moneyDiscount:[
              { validator: isvalidateNumberPoint, trigger: "blur" }
          ],
          discountPwd:[
              { required:true, message:'请输入折扣密码', trigger: "blur" },
              { validator: validatePass, trigger: "blur"}
          ],
          cash:[
              { validator: isvalidateMoney, trigger: "blur" }
          ],
          wechatpayMoney:[
              { validator: isvalidateMoney, trigger: "blur" }
          ],
          alipayMoney:[
              { validator: isvalidateMoney, trigger: "blur" }
          ],
          bankMoney:[
              { validator: isvalidateMoney, trigger: "blur" }
          ],
          oddNumber:[
              { validator: isvalidateoddMoney, trigger: "blur" }
          ],
          feepick:[
            { validator: isvalidatefeeMoney, trigger: "blur" }
          ],
          rechargeAccountMoney:[
            { validator: isvalidateRechargeMoney, trigger: "blur" }
          ],
          giftAccountMoney:[
            { validator: isvalidateGiftMoney, trigger: "blur" }
          ],
          returnMoney:[
            { validator: isvalidateReturnMoney, trigger: "blur" }
          ],
      },
      clickFalg:false,
      printTopContent:'',
      printBottomContent:'',
      brandName:'',
      printDataPost:'',
      putUpFlag:false,
      pagerNumber:2
    };
  },
  computed: {
    molingTotal(){
      let total = 0;
      total = Number(this.total) + Number(this.maxPayInfo.oddsalesNumber);
      return total.toFixed(2)
    },
    huiTotal(){
      let total = 0;
      total = Number(this.total) + Number(this.maxPayInfo.feeNumber);
      return total.toFixed(2)
    },
    MaxDiscountMoney(){
      let cur = this.costForm.moneyDiscount > 0 ? this.costForm.moneyDiscount/10 : 1
      let money = this.total * cur
      return money.toFixed(2)
    },
    MaxMolingMoney(){
      let money = Number(this.total) + Number(this.maxPayInfo.oddsalesNumber) - Number(this.costForm.oddNumber);
      return money.toFixed(2)
    },
    NumbertoFix(){
      return function(val){
        if(val){
          return val
        }else{
          return 0
        }
      }
    },
    paidInAmount(){
        let total = 0;
        total = Number(this.costForm.cash) + Number(this.costForm.wechatpayMoney) + Number(this.costForm.alipayMoney) +　Number(this.costForm.bankMoney) +　Number(this.costForm.rechargeAccountMoney) + Number(this.costForm.giftAccountMoney) + Number(this.costForm.returnMoney);
        return total.toFixed(2);
    },
    giveChange(){
        return (this.paidInAmount - this.total).toFixed(2)
    },
    printPost(){
      return function(data){
        let curdata = data;
        curdata.createTime = formatDate(data.createTime,'yyyy-MM-dd HH:mm');
        let total=[];
        if(data.cash && data.cash>0){
          total.push('现金 ￥'+data.cash.toFixed(2))
        }
        if(data.bankMoney && data.bankMoney>0){
          total.push('银行卡 ￥'+data.bankMoney.toFixed(2))
        }
        if(data.alipayMoney && data.alipayMoney>0){
          total.push('支付宝 ￥'+data.alipayMoney.toFixed(2))
        }
        if(data.wechatpayMoney && data.wechatpayMoney>0){
          total.push('微信 ￥'+data.wechatpayMoney.toFixed(2))
        }
        if(data.rechargeAccountMoney && data.rechargeAccountMoney>0){
          total.push('充值账户 ￥'+data.rechargeAccountMoney.toFixed(2))
        }
        if(data.giftAccountMoney && data.giftAccountMoney>0){
          total.push('赠送账户 ￥'+data.giftAccountMoney.toFixed(2))
        }
        if(data.returnMoney && data.returnMoney>0){
          total.push('返现账户 ￥'+data.returnMoney.toFixed(2))
        }
        curdata.payfeeType = total;
        curdata.giveChange = this.giveChange;
        curdata.amountSale = (Number(data.cutSmallChange?data.cutSmallChange:0) + Number(data.discount?data.discount:0)).toFixed(2);
        return curdata;
      }
    },
    computedMoney(){
      return (val)=>{
        let data = val;
        if(val){
          val.cash = Number(val.cash);
          val.wechatpayMoney = Number(val.wechatpayMoney);
          val.alipayMoney = Number(val.alipayMoney);
          val.bankMoney = Number(val.bankMoney);
          val.rechargeAccountMoney = Number(val.rechargeAccountMoney);
          val.giftAccountMoney = Number(val.giftAccountMoney);
          val.returnMoney = Number(val.returnMoney);
        }
        return data;
      }
    },
    LodoDate(){
      let date=new Date();
      let yearNow = date.getFullYear();
      let mouthNows = date.getMonth() * 1 + 1 < 10 ? "0" + (date.getMonth() * 1 + 1) : (date.getMonth() * 1 + 1);//当前月
      let dayNow = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //当前日
      let LodoDates = yearNow + '-' + mouthNows + '-' + dayNow;
      return LodoDates;
    }
  },
  watch: {
    payAmount(){
      this.changepayAmount()
    },
    activeName(){
      this.changepayAmount()
    },
    'dialogType'(val){
      this.$refs.costForm.clearValidate();
      if(val == 4 ){
        this.list();
      }
    },
    'onpostFlag'(){
      if(this.dialogType == 4 ){
        this.list();
      }
    },
    '$store.state.userInfo.storeCode'(){
      this.$refs.costForm.resetFields();
    },
    'dialogTableVisible'(val){
      if(this.dialogType == 1){
        this.$refs.costForm.resetFields();
        this.activeName = 0;
        this.payAmount = '';
        this.printData()
        this.changepayAmount()
      }
    }
  },
  created() {
    if(this.dialogType == 4 ){
      this.list();
    }
    if(this.dialogType == 1){
      this.printData()
    }
    this.changepayAmount()
  },
  methods: {
    choosePayamount(index){
      this.activeName = index;
    },
    changepayAmount(){
      this.costForm.cash = 0;
      this.costForm.alipayMoney = 0;
      this.costForm.wechatpayMoney = 0;
      this.costForm.bankMoney = 0;
      if(this.activeName == 0){
        this.costForm.cash = this.payAmount;
      }
      if(this.activeName == 1){
        this.costForm.alipayMoney = this.payAmount;
      }
      if(this.activeName == 2){
        this.costForm.wechatpayMoney = this.payAmount;
      }
      if(this.activeName == 3){
        this.costForm.bankMoney = this.payAmount;
      }
      if(!this.memInfo || !this.memInfo.accountOffList || !this.memInfo.accountOffList[0] ){
        this.putUpFlag = false;
      }else if((Number(this.memInfo.accountOffList[0].rechargeOff) == 0 && Number(this.memInfo.accountOffList[0].giftOff) == 0 && Number(this.memInfo.accountOffList[0].backOff) == 0)){
        this.putUpFlag = false;
      }else{
        this.putUpFlag = true;
      }
    },
    putUpItem(){
      this.putUpFlag = !this.putUpFlag;
    },
    operaEntryDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("VIP20198888*7*6*5*4**88882088VIP");
      var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    printData(){
      storeInfo().then(res => {
        if (res.code == 1) {
          this.brandName = res.data.brandId == 1 ? '婷美摩力21产后恢复' : (res.data.brandId == 2 ? '臻幼堂小儿推拿' : '槑博士婴幼儿草本浴');
          this.printTopContent = res.data.printTopContent?(res.data.brandId == 1 ? res.data.printTopContent.split('婷美')[0]:(res.data.brandId == 2?res.data.printTopContent.split('臻幼堂')[0]:(res.data.brandId == 3?res.data.printTopContent.split('槑博士')[0]:''))):'';
          this.pagerNumber = res.data.pagerNumber;
          if(!res.data.printBottomContent || res.data.printBottomContent == ''){
            this.printBottomContent = '温馨提示：请核对小票信息是否准确，若有疑问请与前台联系';//默认内容
          }else{
            this.printBottomContent = res.data.printBottomContent;
          }
        }
      });
    },
    list(){
      queryRestOrder().then(res=>{
        let myData = [];
        for(let i of res.data){
          let ndata = JSON.parse(i.rest);
          ndata.createTime = i.createTime;
          ndata.id = i.id;
          myData.push(ndata);
        }
        this.tableData = myData
      })
    },
    confirmPay(){
      // 结算
      this.$refs.costForm.validate(valid => {
          if (valid) {
            if(this.giveChange < 0){
              this.$confirm( '实收金额不能小于应收金额', "提示", {
                  showCancelButton: false,
                  type: "warning"
              })
            }else{
              this.clickFalg = true;
              this.transmitPost.paidInAmount = this.paidInAmount;
              this.transmitPost.giveChange = this.giveChange;
              let post = Object.assign(this.transmitPost,this.computedMoney(this.costForm));
              addSaleOrder(post).then(res=>{
                this.$message({
                  message: res.msg,
                  type: res.code == 1 ? 'success':'error'
                })
                if(res.code == 1){
                  this.printDataPost = this.printPost(res.data);
                  if(this.listGoodsId){
                    deleteRestOrder({
                      id:this.listGoodsId
                    })
                  }
                  this.costForm = this.$options.data().costForm;
                  this.$refs.costForm.resetFields();
                  setTimeout(() => {
                    this.$emit('closeOpera','removeOprea');
                    // 自动打印
                    if(getLodop()){
                      this.CreatePrintPage();
                      LODOP.SET_PRINT_PAGESIZE(3,0,0,"");
                      LODOP.SET_PRINT_COPIES(Number(this.pagerNumber));
                      // LODOP.PREVIEW();
                      LODOP.PRINT();
                    }
                  });
                }
                setTimeout(()=>{
                  this.clickFalg = false;
                })
              })
            }
          } else {
              this.clickFalg = false;
              console.log("error submit!!");
              return false;
          }
      })
    },
    CreatePrintPage() {
      LODOP=getLodop();
      LODOP.PRINT_INITA('');
      LODOP.ADD_PRINT_TEXT(10,0,'100%','100%',this.printTopContent+String.fromCharCode(13)+this.brandName);
      LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
      LODOP.SET_PRINT_STYLEA(0,"ItemType",1);
      // LODOP.SET_PRINT_STYLEA(0,"Horient",2);
      let brandsize = this.printTopContent ? 58:30

      var strBodyStyle="<style>div{font-size:12px;line-height:18px}div.span8{width: 32%;text-align:center;display: inline-block}div.span4{width: 16%;text-align:center;display: inline-block}div.span6{width: 23%;text-align:center;display: inline-block}div.cont{padding:0 10px}div.table{margin:10px 0}div.printbottomset{padding:10px}</style>";
      var strFormHtml=strBodyStyle+"<body>"+document.getElementById("printCont").innerHTML+"</body>";
      LODOP.ADD_PRINT_HTM(brandsize,0,"100%",$("#printCont").height(),strFormHtml);
    },
    changeCheck(row) {
        if(row.id){
            this.choosecurRow = [];
            if(this.choosecurRow.indexOf(row) == -1){
                this.choosecurRow.push(row);
            }else{
                this.choosecurRow.splice(this.choosecurRow.indexOf(row),1);
            }
            this.$emit('payFeeList',[row]);
        }
    },
    reset(){
      if(this.choosecurRow.length > 0){
        this.$confirm( '确定要清空选中的订单', "提示", {
            distinguishCancelAndClose: true,
            type: "warning"
        })
        .then(() => {
            // this.choosecurRow = [];
            for(let i of this.choosecurRow){
              deleteRestOrder({
                id:i.id
              }).then(res=>{
                if(res.code == 1){
                  this.list();
                  this.choosecurRow = [];
                }
              })
            }
        })
        .catch(action => {
            this.$message({
              type: "info",
              message: "已取消"
            });
        });
      }else{
        this.$confirm( '请先选择订单再清除！', "提示", {
            showCancelButton: false,
            type: "warning"
        })
      }
    },
    payTotal(){
      if(this.choosecurRow.length > 0){
        if(this.choosecurRow.length > 1){
            this.$confirm( '一次只能结算一条订单', "提示", {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                showCancelButton:false,
                type: "error"
            })
            .then(() => {})
            .catch(action => {});
        }else{
            // 回到收银台
            this.$emit('payFeeList',this.choosecurRow);
        }
      }else{
        this.$confirm( '请先选择订单再结算！', "提示", {
            showCancelButton: false,
            type: "warning"
        })
      }
    },
    close(){
        this.$emit('closeOpera',false);
        this.$refs.costForm.resetFields();
    },
    submit(val){
        // 确定
        this.$refs.costForm.validate(valid => {
            if (valid) {

                if(this.dialogType == 2){
                  // checkDiscountKey({
                  //   discountKey:this.operaEntryDES(this.costForm.discountPwd)
                  // }).then(res=>{
                  //   this.$message({
                  //     message: res.msg,
                  //     type: res.code == 1 ? "success" : "error"
                  //   });
                  //   // 1002尚未设置折扣密码跳转到设置密码页
                  //   if(res.code == 1){
                      this.$emit('closeOpera',false);
                      this.$emit('money',val);
                  //   }
                  // })
                }else{
                  this.$emit('closeOpera',false);
                  this.$emit('money',val);
                }
            } else {
                console.log("error submit!!");
                return false;
            }
        })
    }
  }
};
</script>
<style lang="less" scoped>
.collectOperas{
  .accountMoney{
    background: #EEF0F7;
    border-radius: 10px;
    margin: 0 20px 20px;
    padding: 20px 0;
    position: relative;
    .putUp{
      width: 50px;
      background: url(../../assets/images/store/icon_console_up.png) no-repeat center right;
      position: absolute;
      right: 15px;
      top: 25px;
      z-index: 99999;
      &:hover{
        cursor: pointer;
      }
      &.putDown{
        background: url(../../assets/images/store/icon_console_down.png) no-repeat center right;
      }
    }

    .centerFont{
      color:#F83B56;
      font-size: 19px;
      font-weight: bold;
      padding-left: 130px;
    }
  }
  .maxInfo{
    font-size: 16px;
    text-align: center;
    p{
      line-height: 35px;
    }
    .discount{
      font-size: 22px;
    }
  }
  .tableGoods {
    .myTitle {
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .totalAmount{
    border-top: 1px solid #A3A9B6;
    margin: 20px 20px 0;
    padding: 20px 0 0 30px;
    p{
        color: #444;
        font-size: 16px;
        font-weight: bold;
        span{
            color:#F83B56;
            font-size: 19px;
            margin-left: 5px;
        }
        &.netreceipts{
          span{
            color: #222;
          }
        }
    }
  }
}
</style>

<style lang="less">
.dialogOperaVisible {
  width: 100%;
  overflow: hidden;
  text-align: center;

  .seize {
    height: 20px;
  }
  .el-dialog__title {
    font-weight: bold;
  }
  .el-dialog__body{
      padding:25px 0 30px;
      /* 多选 */
    .checkBoxcom .el-checkbox__input.is-checked .el-checkbox__inner{
        background:#F83B56;
        border-color:#F83B56;
    }
    .checkBoxcom .el-checkbox__inner:hover,.checkBoxcom .el-checkbox__input.is-focus .el-checkbox__inner{
    border-color:#F83B56;
    }
    .checkBoxcom .el-checkbox__input.is-checked+.el-checkbox__label,.el-checkbox__label{
        color:#222
    }
  }
  .el-form-item {
    margin-bottom: 18px;
    .el-form-item__label{
        color: #999
    }
  }
  .el-form-item__content {
    text-align: left;
    .account{
        margin-left: 10px;
        color: #F83B56
    }
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
    border-radius: 18px;
  }
  .el-textarea__inner{
    height: 100%;
    border-radius: 18px;
  }
  .el-button.redBtn {
    background: #F83B56;
    color: #fff;
  }
  .totalCash{
      height: 46px;
      line-height: 46px;
      background: #EFF1F5;
      text-align: center;
      p{
          color: #444;
          font-size: 15px;
          font-weight: bold;
          span{
              color:#F83B56;
              font-size: 19px;
              margin-left: 5px;
          }
      }
  }
  .el-button.darkBtn {
    background: #3b404f;
    color: #fff;
  }
  .dialogbtnOptions {
    margin-top: 26px;
    text-align: center;
    .el-button {
      min-width: 105px;
      height: 38px;
      border:none;
    }
  }
  #printCont div{font-size:12px;line-height:18px;width:100%; overflow: hidden;}div.span8{width: 32%;text-align:center;display: inline-block}div.span4{width: 16%;text-align:center;display: inline-block}div.span6{width: 23%;text-align:center;display: inline-block}div.cont{padding:0 10px}div.table{margin:10px 0}div.printbottomset{padding:10px}
}
</style>



// WEBPACK FOOTER //
// src/components/operatingFloor/collectOpera.vue